





















































































































import _ from "lodash";

import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Inspector,CognitoUser } from "@/models";

@Component
export default class InspectorDetail extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("inspectors/hasUnsavedChanges") public hasUnsavedChanges: boolean;

  @Getter("inspectors/current") public inspectors: Inspector;

  @Getter("inspectors/list") public inspectorslist: Inspector[];

  @Mutation("inspectors/setCurrent")
  public setCurrent: (inspectors: Inspector) => void;

  @Action("inspectors/setInspectorsDeep")
  public setInspectorsDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;

  @Action("inspectors/addInspectors")
  public addInspectors: (inspectors: Inspector) => Promise<any>;
  @Action("sysadmin/getUserByUsername")
  public getUserByUsername: (userName: string) => Promise<CognitoUser>;
  @Action("inspectors/updateInspectors")
  public updateInspectors: (inspectors: Inspector) => Promise<any>;

  public mounted() {
    if (this.isNewInspectors()) {
      this.setCurrent(new Inspector());
    }
  }

  get addressLine1() {
    return this.inspectors.address.line1;
  }
  set addressLine1(data) {
    this.setInspectorsDeep({ path: "address.line1", data });
  }

  get addressLine2() {
    return this.inspectors.address.line2;
  }
  set addressLine2(data) {
    this.setInspectorsDeep({ path: "address.line2", data });
  }

  get addressTown() {
    return this.inspectors.address.town;
  }
  set addressTown(data) {
    this.setInspectorsDeep({ path: "address.town", data });
  }

  get addressCounty() {
    return this.inspectors.address.county;
  }
  set addressCounty(data) {
    this.setInspectorsDeep({ path: "address.county", data });
  }

  get addressPostcode() {
    return this.inspectors.address.postcode;
  }
  set addressPostcode(data) {
    this.setInspectorsDeep({ path: "address.postcode", data });
  }

  get companyName() {
    return this.inspectors.companyName;
  }
  set companyName(data) {
    this.setInspectorsDeep({ path: "companyName", data });
  }

  get email() {
    return this.inspectors.email;
  }
  set email(data) {
    this.setInspectorsDeep({ path: "email", data });
  }

  get phone() {
    return this.inspectors.phone;
  }
  set phone(data) {
    this.setInspectorsDeep({ path: "phone", data });
  }

  public canAdd() {
    let result = true;
    if (!this.addressLine1 || !this.addressTown || !this.addressPostcode || !this.email || !this.phone)
      result = false;
    return result;
  }

  public canSave() {
    let result = true;
    if (!this.addressLine1 || !this.addressTown || !this.addressPostcode || !this.email || !this.phone)
      result = false;
    return result;
  }

  public isNewInspectors() {
    return this.$router.currentRoute.params.id == "new";
  }

  public isSaving: boolean = false;
  public async saveAll() {
    if (this.isNewInspectors()) {
      this.isSaving = true;
      let cognitoUser = await this.getUserByUsername(this.email);
      if (cognitoUser != null && cognitoUser.Username != '') {
        this.isSaving = false;
        this.$toasted.error("User Already Exist");
        return;
      } else {
        this.addInspectors(this.inspectors).then(() => {
        this.isSaving = false;
        this.$toasted.success("Added");
        this.$router.push("/inspectors");
      });
      }
     
    } else {
      this.isSaving = true;
      this.updateInspectors(this.inspectors).then(() => {
        this.isSaving = false;
        this.$toasted.success("Saved");
        this.$router.push("/inspectors");
      });
    }
  }

  public cancel() {
    this.setCurrent(new Inspector());
    this.$router.push("/inspectors");
  }
}
